import { render, staticRenderFns } from "./FirstTab.vue?vue&type=template&id=7b8ee46d"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"
import style0 from "./FirstTab.vue?vue&type=style&index=0&id=7b8ee46d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/app/nuxt/components/Loading.vue').default,Section: require('/app/nuxt/components/Section.vue').default})
